const BACKEND_URL = "foo";

//finds page's submenu
export function findMenuSliceWithPageId(pageId, menu){
    for(let i = 0; i < menu.items.length; i++){
        let item = menu.items[i];
        if(item.object_id == pageId){
            return item;
        }
        if(item.child_items){
            let subItem = handleSubItems(pageId, item.child_items);
            if(subItem){
                //return subItem;

                //returns menu from parent level
                return item;
            }
        }
    }
    return undefined;
}

function handleSubItems(pageId, items){
    for(let i = 0; i < items.length; i++){
        let item = items[i];
        if(item.object_id == pageId){
            return item;
        }
        if(item.child_items){
            let subItem = handleSubItems(pageId, item.child_items);
            if(subItem){
                return subItem;
            }
        }
    }
    return undefined;
}

export function replaceBackEndUrlFromMenu(menu){
    for(let i = 0; i < menu.items.length; i++){
        let item = menu.items[i];
        item.url = replaceBackEndUrl(item.url);

        if(item.child_items){
            item.child_items = replaceBackEndUrlFromSubItems(item.child_items);
        }

        menu.items[i] = item;
    }
    return menu;
}

function replaceBackEndUrlFromSubItems(items){
    for(let i = 0; i < items.length; i++){
        let item = items[i];
        item.url = replaceBackEndUrl(item.url);

        if(item.child_items){
            item.child_items = replaceBackEndUrlFromSubItems(item.child_items);
        }

        items[i] = item;
    }
    return items;
}

//can be used to remove hardcoded wordpress url from strings
export function replaceBackEndUrl(urlToReplace, replaceWith = ""){
    return urlToReplace.replace(BACKEND_URL, replaceWith);
}

//used to convert some symbols so they display correctly in title-tag
export function convertTitleToReadable(title){
    title = title.replace('&#038;', '&');
	title = title.replace("&#8217;", "'");

    return title;
}